import { context, styled } from "../../util/style.js";

import { REVENUES_STEPS } from "./data.js";

const MAX_BAR_WIDTH = 920;
const BAR_STEPS = [325 - 100, 560 - 100, 796 - 100, MAX_BAR_WIDTH];

export function getBarWidth(revenue) {
  if (revenue <= REVENUES_STEPS[0]) {
    return (BAR_STEPS[0] * revenue) / REVENUES_STEPS[0];
  }
  if (revenue <= REVENUES_STEPS[1]) {
    return (
      BAR_STEPS[0] +
      ((BAR_STEPS[1] - BAR_STEPS[0]) * (revenue - REVENUES_STEPS[0])) /
        (REVENUES_STEPS[1] - REVENUES_STEPS[0])
    );
  }
  if (revenue <= REVENUES_STEPS[2]) {
    return (
      BAR_STEPS[1] +
      ((BAR_STEPS[2] - BAR_STEPS[1]) * (revenue - REVENUES_STEPS[1])) /
        (REVENUES_STEPS[2] - REVENUES_STEPS[1])
    );
  }
  return Math.min(
    MAX_BAR_WIDTH,
    BAR_STEPS[2] +
      ((BAR_STEPS[3] - BAR_STEPS[2]) * (revenue - REVENUES_STEPS[2])) /
        (REVENUES_STEPS[3] - REVENUES_STEPS[2]),
  );
}

export default styled(function RevenueGraph({ revenue, className }) {
  const barWidth = getBarWidth(revenue);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="98 14 924 240"
      className={className}
    >
      <g>
        <rect
          fill="#707070"
          stroke="#707070"
          strokeWidth="3"
          x="100"
          y="163"
          width={MAX_BAR_WIDTH}
          height="86"
          rx="43"
          ry="43"
        />
        <rect
          fill={
            revenue <= REVENUES_STEPS[0]
              ? "#2e91d0"
              : revenue <= REVENUES_STEPS[1]
              ? "#1d70b7"
              : revenue <= REVENUES_STEPS[2]
              ? "#075895"
              : "#00427c"
          }
          x="100"
          y={163 + (43 - Math.min(barWidth / 2, 43))}
          width={barWidth}
          height={Math.min(barWidth, 86)}
          rx={Math.min(barWidth / 2, 43)}
          ry={Math.min(barWidth / 2, 43)}
        />
      </g>

      <g>
        {/* <rect
          fill="#2e91d0"
          x="100"
          y="163"
          width="266"
          height="86"
          rx="43"
          ry="43"
        /> */}
        <text x="202" y="148" className="step-name" textAnchor="middle">
          PALIER 1
        </text>
        <text x="202" y="200" className="step-before" textAnchor="middle">
          1K€ DE CA
        </text>
        <text x="202" y="220" className="step-after" textAnchor="middle">
          = 1€ CADEAUX
        </text>
      </g>

      <g>
        <path
          className="circle"
          d="M352.721,73.939c-10.716,17.35-33.469,22.728-50.819,12.012-17.35-10.716-22.728-33.469-12.012-50.819,10.716-17.35,33.469-22.728,50.819-12.012,4.158,2.568,7.764,5.936,10.611,9.908"
        />
        <path
          fill="#2d2d2e"
          d="M368.835,42.403c3.095-.002,6.09,1.092,8.455,3.088l.993.84v-4.633l-.272-.179c-7.737-5.066-18.116-2.9-23.182,4.837-1.051,1.605-1.818,3.379-2.268,5.244h-5.057l-.9,2.413h5.56c-.044.5-.07,1-.07,1.508s.026,1.009.07,1.508h-3.056l-.9,2.413h4.349c2.171,8.99,11.218,14.519,20.208,12.348,1.864-.45,3.637-1.217,5.242-2.267l.272-.179v-4.634l-.993.84c-5.545,4.669-13.824,3.96-18.494-1.585-1.119-1.329-1.963-2.866-2.483-4.523h11.853l.9-2.413h-13.255c-.118-1.002-.118-2.013,0-3.015h14.375l.9-2.413h-14.769c1.717-5.472,6.787-9.197,12.522-9.2v.002Z"
        />
        <line
          stroke="#575257"
          x1="325.024"
          y1="162.887"
          x2="325.024"
          y2="108.153"
        />
        <text x="341" y="53" className="step-value" textAnchor="end">
          {REVENUES_STEPS[0] / 1000}K
        </text>
        <text x="341" y="71" className="step-label" textAnchor="end">
          CA
        </text>
      </g>

      <g>
        {/* <rect
          fill="#1d70b7"
          x="280"
          y="163"
          width="324"
          height="86"
          rx="43"
          ry="43"
        /> */}
        <g>
          <circle fill="#ffffff" cx="325" cy="206" r="30" />
          <path
            fill="#dac682"
            d="M323.752,198.556c.583.583,6.361,6.627,6.361,6.627.615.585.638,1.558.053,2.173-.017.018-.035.036-.053.053,0,0-5.778,6.1-6.361,6.627-.638.61-1.642.61-2.28,0-.615-.55-.668-1.495-.117-2.11.037-.041.076-.081.117-.117l5.3-5.513-5.3-5.513c-.615-.55-.668-1.495-.117-2.11.037-.041.076-.081.117-.117.638-.61,1.642-.61,2.28,0Z"
          />
        </g>
        <text x="440" y="148" className="step-name" textAnchor="middle">
          PALIER 2
        </text>
        <text x="440" y="200" className="step-before" textAnchor="middle">
          1K€ DE CA
        </text>
        <text x="440" y="220" className="step-after" textAnchor="middle">
          = 2€ CADEAUX
        </text>
      </g>

      <g>
        <path
          className="circle"
          d="M588.535,73.939c-10.716,17.35-33.469,22.728-50.819,12.012-17.35-10.716-22.728-33.469-12.012-50.819,10.716-17.35,33.469-22.728,50.819-12.012,4.158,2.568,7.764,5.936,10.611,9.908"
        />
        <path
          fill="#2d2d2e"
          d="M604.649,42.403c3.095-.002,6.09,1.092,8.455,3.088l.993.84v-4.633l-.272-.179c-7.737-5.066-18.116-2.9-23.182,4.837-1.051,1.605-1.818,3.379-2.268,5.244h-5.057l-.9,2.413h5.56c-.044.5-.07,1-.07,1.508s.026,1.009.07,1.508h-3.056l-.9,2.413h4.349c2.171,8.99,11.218,14.519,20.208,12.348,1.864-.45,3.637-1.217,5.242-2.267l.272-.179v-4.634l-.993.84c-5.545,4.669-13.824,3.96-18.494-1.585-1.119-1.329-1.963-2.866-2.483-4.523h11.853l.9-2.413h-13.255c-.118-1.002-.118-2.013,0-3.015h14.375l.9-2.413h-14.769c1.717-5.472,6.787-9.197,12.522-9.2v.002Z"
        />
        <line
          stroke="#575257"
          x1="560.838"
          y1="162.887"
          x2="560.838"
          y2="108.153"
        />
        <text x="578" y="53" className="step-value" textAnchor="end">
          {REVENUES_STEPS[1] / 1000}K
        </text>
        <text x="578" y="71" className="step-label" textAnchor="end">
          CA
        </text>
      </g>

      <g>
        {/* <rect
          fill="#075895"
          x="517"
          y="163"
          width="324"
          height="86"
          rx="43"
          ry="43"
        /> */}
        <g>
          <circle fill="#ffffff" cx="560" cy="206" r="30" />
          <path
            fill="#dac682"
            d="M559.566,198.556c.583.583,6.361,6.627,6.361,6.627.615.585.638,1.558.053,2.173-.017.018-.035.036-.053.053,0,0-5.778,6.1-6.361,6.627-.638.61-1.642.61-2.28,0-.615-.55-.668-1.495-.117-2.11.037-.041.076-.081.117-.117l5.3-5.513-5.3-5.513c-.615-.55-.668-1.495-.117-2.11.037-.041.076-.081.117-.117.638-.61,1.642-.61,2.28,0Z"
          />
        </g>
        <text x="677" y="148" className="step-name" textAnchor="middle">
          PALIER 3
        </text>
        <text x="677" y="200" className="step-before" textAnchor="middle">
          1K€ DE CA
        </text>
        <text x="677" y="220" className="step-after" textAnchor="middle">
          = 3€ CADEAUX
        </text>
      </g>

      <g>
        <path
          className="circle"
          d="M824.348,73.939c-10.716,17.35-33.469,22.728-50.819,12.012-17.35-10.716-22.728-33.469-12.012-50.819,10.716-17.35,33.469-22.728,50.819-12.012,4.158,2.568,7.764,5.936,10.611,9.908"
        />
        <path
          fill="#2d2d2e"
          d="M840.462,42.403c3.095-.002,6.09,1.092,8.455,3.088l.993.84v-4.633l-.272-.179c-7.737-5.066-18.116-2.9-23.182,4.837-1.051,1.605-1.818,3.379-2.268,5.244h-5.057l-.9,2.413h5.56c-.044.5-.07,1-.07,1.508s.026,1.009.07,1.508h-3.056l-.9,2.413h4.349c2.171,8.99,11.218,14.519,20.208,12.348,1.864-.45,3.637-1.217,5.242-2.267l.272-.179v-4.634l-.993.84c-5.545,4.669-13.824,3.96-18.494-1.585-1.119-1.329-1.963-2.866-2.483-4.523h11.853l.9-2.413h-13.255c-.118-1.002-.118-2.013,0-3.015h14.375l.9-2.413h-14.769c1.717-5.472,6.787-9.197,12.522-9.2v.002Z"
        />
        <line
          stroke="#575257"
          x1="796.651"
          y1="162.887"
          x2="796.651"
          y2="108.153"
        />
        <text x="815" y="53" className="step-value" textAnchor="end">
          {REVENUES_STEPS[2] / 1000}K
        </text>
        <text x="815" y="71" className="step-label" textAnchor="end">
          CA
        </text>
      </g>

      <g>
        {/* <rect
          fill="#00427c"
          x="754"
          y="163"
          width="266"
          height="86"
          rx="43"
          ry="43"
        /> */}
        <g>
          <circle fill="#ffffff" cx="796" cy="206" r="30" />
          <path
            fill="#dac682"
            d="M795.379,198.556c.583.583,6.361,6.627,6.361,6.627.615.585.638,1.558.053,2.173-.017.018-.035.036-.053.053,0,0-5.778,6.1-6.361,6.627-.638.61-1.642.61-2.28,0-.615-.55-.668-1.495-.117-2.11.037-.041.076-.081.117-.117l5.3-5.513-5.3-5.513c-.615-.55-.668-1.495-.117-2.11.037-.041.076-.081.117-.117.638-.61,1.642-.61,2.28,0Z"
          />
        </g>
        <text x="914" y="148" className="step-name" textAnchor="middle">
          PALIER 4
        </text>
        <text x="914" y="200" className="step-before" textAnchor="middle">
          1K€ DE CA
        </text>
        <text x="914" y="220" className="step-after" textAnchor="middle">
          = 4€ CADEAUX
        </text>
      </g>
    </svg>
  );
})`
  display: block;
  margin: 24px -32px;
  ${context("for-tablet-landscape")`
    display: none;
  `}

  .circle {
    stroke: #2d2d2e;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 4px;
    fill: transparent;
  }

  .step-value {
    fill: #0d97e2;
    font-weight: 700;
    font-size: 16px;
  }
  .step-label {
    fill: #0d97e2;
    font-weight: 700;
    font-size: 16px;
  }
  .step-name {
    fill: #575257;
    font-weight: 400;
    font-size: 14px;
  }
  .step-before {
    fill: #ffffff;
    font-weight: 400;
    font-size: 16px;
  }
  .step-after {
    fill: #ffffff;
    font-weight: 700;
    font-size: 16px;
  }
  .reversed {
    fill: #ffffff;
  }
`;
